import { render, staticRenderFns } from "./input-suffix.vue?vue&type=template&id=936f0d7a"
import script from "./input-suffix.vue?vue&type=script&lang=js"
export * from "./input-suffix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports